export default __webpack_public_path__ + "static/media/polygon-logo-white.23e0037e.svg";